import { BreakpointsOptions } from '@mui/material'

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 375,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
}

const colors = {
  green: {
    50: '#e0f9e9',
    100: '#b3efca',
    200: '#7ae4a7',
    300: '#06d981',
    400: '#00cf63',
    500: '#00c34a',
    600: '#00b340',
    700: '#00a133',
    800: '#008f27',
    900: '#006e11',
  },
  grey: {
    50: '#FAFAFA',
    100: '#F1F1F1',
    200: '#E7E7E7',
    300: '#D5D5D5',
    400: '#CCCCCC',
    500: '#999999',
    600: '#757575',
    700: '#454545',
    800: '#303030',
    900: '#202020',
  },
  red: {
    50: '#fce8e7',
    100: '#ffcabc',
    200: '#ffa891',
    300: '#ff8465',
    400: '#ff6843',
    500: '#ff4a23',
    600: '#f9441f',
    700: '#eb3d1a',
    800: '#dd3515',
    900: '#c4260b',
  },
  teal: {
    50: '#D0FFFF',
    100: '#84FFFB',
    200: '#0CEAE2',
    300: '#00D0C8',
    400: '#00B3AB',
    500: '#00A499',
    600: '#00968B',
    700: '#00867A',
    800: '#00756A',
    900: '#00594B',
  },
  yellow: {
    50: '#fff8e0',
    100: '#ffebb0',
    200: '#ffde7d',
    300: '#ffd345',
    400: '#ffc711',
    500: '#ffbe00',
    600: '#ffb000',
    700: '#ff9c00',
    800: '#ff8b00',
    900: '#ff6900',
  },
  white: '#ffffff',
  black: '#000000',
  background: '#f8f8f8',
  sidebar: '#101010',
  xbox: '#0e7a0d',
  playstation: '#003791',
  successGreen: '#55910b',
}

export { breakpoints, colors }
